import { createPortal } from "react-dom";
import { useContext, useRef, useState } from "react";
import "./EditRow.scss";
import { AppContext } from "../../Context/AppContext";
import { editRow } from "../CommonFunc";
const columnNames = {
	DESCRIPTION: "Пользовательское имя файла",
	USER_DATE: "Дата",
};
function EditRow(props) {
	const [info, setInfo] = useState(undefined);
	const inputRef = useRef();
	const { theme } = useContext(AppContext);
	const [currentData, setCurrentData] = useState(props.data);
	const handleCreate = () => {
		editRow(currentData)
			.then((id) => {
				props.fillRows();
				props.setEditable(false);
			})
			.catch((e) => {
				// setInfo({ message: e.response.data });
			});
	};
	const onChange = (e, item) => {
		setCurrentData((prev) => ({ ...prev, [item]: e.target.value }));
	};
	return createPortal(
		<div
			className='edit-row-dialog-wrapper'
			color={theme.color}
			style={{
				fontSize: `${(18 / theme.scaleFactor) * theme.fontMultiplier}px`,
			}}
		>
			{/* <Notifications info={info} setInfo={setInfo} /> */}
			<div className='edit-row-dialog'>
				{Object.keys(currentData).map((item, i) => {
					if (item.toUpperCase() === "USER_DATE") {
						const rawDate = new Date(currentData[item]);
						const yyyy = rawDate.getFullYear();
						const mm = (rawDate.getMonth() + 1).toString().padStart(2, "0");
						const dd = rawDate.getDate().toString().padStart(2, "0");
						const date = `${yyyy}-${mm}-${dd}`;
						return (
							<div className='dialog-row'>
								<label>{columnNames[item]}</label>
								<input
									key={i}
									className='name-field'
									type='date'
									value={date}
									onChange={(e) => onChange(e, item)}
									// autoFocus
								/>
							</div>
						);
					} else if (
						item.toUpperCase() === "ID" ||
						item.toUpperCase() === "EXT" ||
						item.toUpperCase() === "CONT_SIZE" ||
						item.toUpperCase() === "ORIG_NAME" ||
						item.toUpperCase() === "DOWNLOAD" ||
						item.toUpperCase() === "DELETE"
					) {
						return <></>;
					} else {
						return (
							<div className='dialog-row'>
								<label>{columnNames[item]}</label>
								<input
									key={i}
									className='name-field'
									type='text'
									value={currentData[item]}
									onChange={(e) => onChange(e, item)}
									// autoFocus
								/>
							</div>
						);
					}
				})}
				<div className='edit-row-dialog-actions'>
					<div className='create-button' onClick={handleCreate}>
						Сохранить
					</div>
					<div
						className='close-button'
						onClick={() => props.setEditable(false)}
					>
						Закрыть
					</div>
				</div>
			</div>
		</div>,
		document.getElementById("editRow")
	);
}

export default EditRow;
